import { render, staticRenderFns } from "./AdminTrainingForm.vue?vue&type=template&id=72003424&scoped=true&"
import script from "./AdminTrainingForm.vue?vue&type=script&lang=js&"
export * from "./AdminTrainingForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminTrainingForm.vue?vue&type=style&index=0&id=72003424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72003424",
  null
  
)

export default component.exports